import dayjs from 'dayjs';

export function formatCreatedAt(date) {
  const parsed = dayjs(date);
  return `${parsed.format('YYYY-MM-DD')} @ ${parsed.format('HH:mm:ss')}`;
}

export function formatCreatedAtWithTimeZone(date) {
  const parsed = dayjs(date);
  return `${parsed.format('YYYY-MM-DD')} ${parsed.format('HH:mm:ss')} GMT${parsed.format('Z')}`;
}

export function isWithinTimeFrame(start, end, dateToCheck) {
  return (!start || dateToCheck >= start) && (!end || dateToCheck <= end);
}

export const parse = str => dayjs(str);
